const initState =
{
  drawer01      : false,
  drawer02      : false,
  drawer03      : false,
  drawer04      : false,
}

const drawersReducer = (state = initState, action) =>
{
  switch (action.type)
  {    
    case 'SET_DRAWER_01':
      return {
        ...state,
        drawer01: action.drawer01
      };

    case 'SET_DRAWER_02':
      return {
        ...state,
        drawer02: action.drawer02
      };

    case 'SET_DRAWER_03':
      return {
        ...state,
        drawer03: action.drawer03
      };

    case 'SET_DRAWER_04':
      return {
        ...state,
        drawer04: action.drawer04
      };

    default:
      return state; 
  }
}

export default drawersReducer;